import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MyNotification } from '@prowodo/angular-client';
import { NotificationInboxService } from '@app/services/notification-inbox.service';

@Component({
  selector: 'app-notification-list',
  standalone: true,
  imports: [CommonModule, DatePipe, RouterModule, MatIconModule, MatButtonModule, MatDividerModule],
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss',
})
export class NotificationListComponent implements OnInit {
  notifications$ = this.inboxService.notifications$;
  showAll$ = this.inboxService.showAll$;

  constructor(
    private inboxService: NotificationInboxService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.inboxService.load();
  }

  clickNotification(notification: MyNotification): void {
    if (!notification.is_read) {
      this.inboxService.markAsRead(notification.id).subscribe();
    }
    const link = notification.action?.['link'];
    if (link) {
      this.router.navigateByUrl(link);
    }
  }

  dismiss(event: Event, notification: MyNotification): void {
    event.stopPropagation();
    this.inboxService.dismiss(notification.id).subscribe();
  }

  toggleShowAll(event: Event): void {
    event.stopPropagation();
    this.inboxService.toggleShowAll();
  }
}
